module.exports = __webpack_public_path__ + "static/img/144.8044300.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/144.png
// module id = F0Si
// module chunks = 0